import styled from 'styled-components';
import { Table } from 'ui/table';
import { TableHeader } from 'ui/tableHeader';
import { colors, duration, easing, fontSizes, fontWeights, spacing } from 'ui/theme';
import { HeaderCell } from 'ui/tableHeaderCell';
import { pxToRem } from 'utils/convert';

export const BlockTableWrapper = styled.div`
  border: none;
  flex: 1 0 auto;
  position: relative;
  height: 100%;
`;

export const StyledTable = styled(Table)`
  display: block;
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.quarter};

  & > div:last-child > div:first-of-type {
    border-bottom-left-radius: ${spacing.quarter};
  }
  & > div:last-child > div:last-of-type {
    border-bottom-right-radius: ${spacing.quarter};
  }
`;

export const StyledTableHeader = styled(TableHeader)`
  border-radius: ${spacing.quarter};
  && ${HeaderCell} {
    border-radius: ${spacing.quarter};
    padding: ${spacing.base};
  }
`;

export const BlockCellWrapper = styled.div`
  border-color: transparent;
  border-style: solid;
  border-width: ${spacing.single};
  column-gap: ${spacing.base};
  display: flex;
  padding: ${spacing.base};
  position: relative;
  transition: all ${duration.short} ${easing.entrance};
  &[data-selected='true'] {
    background-color: ${colors.backgroundInteractive};
    border-color: ${colors.borderInteractive};
    color: ${colors.iconInteractive};
  }
  &[data-selected='false'] {
    background-color: transparent;
  }
  &[data-has-click='true'] {
    cursor: pointer;
    user-select: none;
    &:hover {
      &[data-selected='true'] {
        background-color: ${colors.backgroundInteractive};
      }
      &[data-selected='false'] {
        background-color: ${colors.backgroundTertiary};
      }
    }
  }
  &[data-has-click='false'] {
    cursor: default;
  }
`;

// left section of the list item containing the preview image
export const BlockItemPreview = styled.div<{ $imgSrc: string }>`
  background-image: url(${({ $imgSrc }) => $imgSrc});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: ${spacing.threeEights};
  flex: 0 0 auto;
  height: ${pxToRem(48)};
  width: ${pxToRem(56)};
`;

// center section of the list item containing the name & file info (progress bar || file data || error)
export const BlockItemData = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  width: 1px; /** arbitrary starting point for filling the remaining space (necessary for ellipsis of child) */

  &[data-loading='true'] {
    gap: ${spacing.threeEights};
  }
`;

// file name within BlockItemData
export const BlockItemTitle = styled.div`
  font-size: ${fontSizes.s14};
  font-weight: ${fontWeights.medium};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// file data (size, width, height, ... || error reponse) within LisItemData
export const BlockItemDetail = styled.div`
  color: ${colors.textSecondary};
  display: block;
  font-size: ${fontSizes.s12};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
